// @ts-nocheck
import { Modal } from "antd";
import { useEffect, useState, useImperativeHandle, useRef } from "preact/hooks";
import { forwardRef } from "react";
import { h } from "preact";
import { useForm } from "react-hook-form";
import BaseForm from "../../../../components/form";
import { useMessage } from "../../../../hooks/useMessage";
import {
  DETAIL_MAINTENANCE_TECH_END_JOB,
  FORM_MAINTENANCE_DATA,
} from "../../constants/forms";
import { IPropsModal } from "../../interface/modal";
import {
  ContainerEditModalRepair,
  ContainerImageAndForm,
  ContainerShowDetail,
} from "../../styled";
import ComponentDivider from "../../../../components/divider";
import { ShowImage } from "../../../../components/image";
import moment from "moment";
import { useGet } from "../../hook/useGet";
import { Text } from "../../../../components/text";
import { PUT, UPDATE_MAINTENANCE } from "../../../../services";
import { ModalConfirmGetJob } from "./confirm-get-job";
import { ModalConfirmTechGetJob } from "./confirm-tech-get-job";
import { ModalEndJobTech } from "./end-job-tech";
import { ModalEndJob } from "./end-job";
import { DEFAULT_STATE } from "../../constants/default-status";

const EditData = (props: any, ref) => {
  const modalRefComfirmGetjob = useRef<IModalRef>();
  const modalRefTechComfirmGetjob = useRef<IModalRef>();
  const modalRefTechEndJob = useRef<IModalRef>();
  const modalRefEndJob = useRef<IModalRef>();
  const { options, onCallbackEdit } = props;
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { openMessage } = useMessage();
  const {
    useGetMaintenancesImages,
    stateMaintenancesImage,
    setStateMaintenancesImage,
    useGetMaintenancesLine,
    stateMaintenancesLine,
  } = useGet();
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: DEFAULT_STATE,
  });

  useEffect(() => {
    if (!visible) {
      reset();
      setStateMaintenancesImage([]);
    }
  }, [visible]);

  useEffect(() => {
    if (stateMaintenancesLine) {
      for (const key in stateMaintenancesLine) {
        const element = stateMaintenancesLine[key];
        if (key in DEFAULT_STATE) {
          setValue(key as keyof typeof DEFAULT_STATE, element);
        }
      }
    }
  }, [stateMaintenancesLine]);

  useImperativeHandle(ref, () => ({
    async openModal(e: any) {
      try {
        await Promise.all([
          useGetMaintenancesImages(e.maintainId),
          useGetMaintenancesLine(e.maintainId),
        ]);
        const createDate = moment(e.createDate);
        const eData = { ...e, createDate };
        for (const key in eData) {
          const element = eData[key];
          if (key in DEFAULT_STATE) {
            setValue(key as keyof typeof DEFAULT_STATE, element);
          }
        }
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  const onConfirm = async (values) => {
    setLoading(true);
    try {
      const {
        maintainStatusId,
        maintainId,
        remark,
        deviceId,
        customerName,
        customerCode,
      } = values;
      const obj = {
        deviceId,
        customerName,
        customerCode,
        maintainId,
        remark,
        statusId: maintainStatusId,
      };

      const res = await PUT(UPDATE_MAINTENANCE, obj);
      if (!res.success) {
        return;
      }
      openMessage("success", res.message);
      onCallbackEdit && onCallbackEdit(getValues());
      onRefresh && onRefresh();
      setVisible(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  function onOpenModal() {
    const { maintainStatusId } = getValues();
    switch (maintainStatusId) {
      case "STPH-002":
      case "STPH-003":
      case "STPH-004":
        modalRefComfirmGetjob.current &&
          modalRefComfirmGetjob.current.openModal(getValues());
        break;
      case "STPH-005":
        modalRefTechComfirmGetjob.current &&
          modalRefTechComfirmGetjob.current.openModal(getValues());
        break;
      case "STPH-006":
        modalRefTechEndJob.current &&
          modalRefTechEndJob.current.openModal(getValues());
        break;
      case "STPH-007":
        modalRefEndJob.current && modalRefEndJob.current.openModal(getValues());
        break;
      default:
    }
  }

  function onChange(e, item) {
    // onOpenModal(item);
    setValue(item.ref, e.target.value);
  }

  return (
    <Modal
      centered
      width={1200}
      title={(<Text size={"L"} text="แก้ไขข้อมูล" bold />) as React.ReactNode}
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ปิด"}
      onOk={handleSubmit(onConfirm)}
      onCancel={() => setVisible(false)}
      destroyOnClose={() => setVisible(false)}
      confirmLoading={loading}
      transitionName={""}
      okButtonProps={
        {
          // disabled: getValues().maintainStatusId === "STPH-100",
        }
      }
      // footer={[
      //   <ContainerModalFooterSingle key="1">
      //     <Button type="default" onClick={() => setVisible(false)}>ยกเลิก</Button>
      //     <Button type="primary" onClick={handleSubmit(onConfirm)}>บันทึก</Button>
      //     <ButtonColor type="primary" color={color.green} onClick={() => onOpenParentModal(getValues())}>ถัดไป</ButtonColor>
      //   </ContainerModalFooterSingle>,
      // ]}
    >
      {visible &&
        ((
          <ContainerEditModalRepair>
            <ContainerShowDetail>
              {
                (
                  <BaseForm
                    control={control}
                    forms={FORM_MAINTENANCE_DATA({
                      options,
                      disabled: getValues().maintainStatusId === "STPH-100",
                    })}
                    setValue={setValue}
                    getValues={getValues}
                    onChange={onChange}
                  />
                ) as React.ReactNode
              }

              <ComponentDivider />
              <ContainerImageAndForm style={{ margin: "1rem 0" }}>
                <ShowImage image={stateMaintenancesImage} />
              </ContainerImageAndForm>
            </ContainerShowDetail>
            <ComponentDivider type="vertical" />
            <ContainerShowDetail style={{ width: "40%", marginLeft: "1rem" }}>
              <BaseForm
                control={control}
                forms={DETAIL_MAINTENANCE_TECH_END_JOB()}
                setValue={setValue}
                getValues={getValues}
              />
            </ContainerShowDetail>
          </ContainerEditModalRepair>
        ) as React.ReactNode)}

      <ModalConfirmGetJob
        ref={modalRefComfirmGetjob}
        onCallbackEdit={() => onCallbackEdit(getValues())}
        onBeforeConfirm={onConfirm}
      />
      <ModalConfirmTechGetJob
        ref={modalRefTechComfirmGetjob}
        onCallbackEdit={() => onCallbackEdit(getValues())}
        onBeforeConfirm={onConfirm}
      />
      <ModalEndJobTech
        ref={modalRefTechEndJob}
        onCallbackEdit={() => onCallbackEdit(getValues())}
        onBeforeConfirm={onConfirm}
      />
      <ModalEndJob
        ref={modalRefEndJob}
        onCallbackEdit={(e: IStateChangeMain) => onCallbackEdit(e)}
      />
    </Modal>
  );
};

export const ModalEditData = forwardRef<any, any>(EditData);
